import React from 'react';
import PropTypes from 'prop-types';
import { StudentWatchedPercentageDetails } from './StudentWatchedPercentageDetails';
import createStudentDetailsList from './createStudentDetailsList';

const VideoProgressDetails = ({ progress, progressDetailsId }) => {
  const {
    not_started: notStarted,
    started,
    watched,
    student_progress: studentProgress,
  } = progress;
  const {
    studensWhoHasNotStarted,
    studentsWhoHasStarted,
    studentsWhoHasCompleted,
  } = createStudentDetailsList(studentProgress);
  return (
    <div id={progressDetailsId} className="grid grid-cols-3 gap-x-6 py-14">
      <StudentWatchedPercentageDetails
        userNumber={notStarted}
        progressType="Not Started"
        classNames="text-black bg-gray-400"
      >
        {studensWhoHasNotStarted}
      </StudentWatchedPercentageDetails>
      <StudentWatchedPercentageDetails
        userNumber={started}
        progressType="In Progress"
        classNames="text-purple-700 bg-pink-200"
      >
        {studentsWhoHasStarted}
      </StudentWatchedPercentageDetails>
      <StudentWatchedPercentageDetails
        userNumber={watched}
        progressType="Watched"
        classNames="text-pink-200 bg-purple-700"
      >
        {studentsWhoHasCompleted}
      </StudentWatchedPercentageDetails>
    </div>
  );
};

VideoProgressDetails.displayName = 'VideoProgressDetails';
VideoProgressDetails.defaultProps = {
  progress: {},
};
VideoProgressDetails.propTypes = {
  progress: PropTypes.shape({
    not_started: PropTypes.number,
    started: PropTypes.number,
    watched: PropTypes.number,
    total_students: PropTypes.number,
  }),
  progressDetailsId: PropTypes.string.isRequired,
};

export default VideoProgressDetails;
